const getParameterByName = function(url: string, name: string) {
    const param = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export default function(url: string, page: number, sort: string) {
    const params = {} as { [key:string]: string|number };
    const keywords = getParameterByName(url, 'keywords');

    if (page !== 1) {
        params.page = page;
    }

    if (sort !== 'asc') {
        params.sort = sort;
    }

    if (keywords) {
        params.keywords = keywords;
    }

    const esc = encodeURIComponent;
    const query = Object.keys(params)
        .map((k) => esc(k) + '=' + esc(params[k]))
        .join('&');

    if (url.includes('?')) {
        url = (url.split('?'))[0];
    }

    if (query === '') {
        return url;
    }

    return url + '?' + query;
}
